import { FormErrors } from 'types'
import { isValidEmail } from 'services/email'
import { useCallbackBasedFormSubmitHandlers, useForm, useFormValidator } from 'hooks/form'

export interface IAddReferenceFormValues {
  firstName: string
  lastName: string
  email: string
  message: string
}

function validate(values: IAddReferenceFormValues) {
  const errors = {} as FormErrors<IAddReferenceFormValues>

  if (!values.firstName) {
    errors.firstName = 'Required'
  }

  if (!values.lastName) {
    errors.lastName = 'Required'
  }

  if (!values.email) {
    errors.email = 'Required'
  } else if (!isValidEmail(values.email)) {
    errors.email = 'Invalid email address'
  }

  if (values.message && values.message.length > 1000) {
    // also validated on the Reference model
    errors.message = '1000 characters max'
  }

  return errors
}

export function useAddReferenceForm(initialValues: Partial<IAddReferenceFormValues> = {}, onSubmit: (values: IAddReferenceFormValues) => void) {
  // TODO: it should be possible to run the add reference mutation from here
  // the reason it's done higher up is to implement a fetchKey workaround
  // should be fixed, and then this should use mutation based submit handlers
  const form = useForm<IAddReferenceFormValues, any>({
    defaultValues: initialValues,
    resolver: useFormValidator(validate),
    submitHandlers: useCallbackBasedFormSubmitHandlers(onSubmit),
  })

  return form
}
